module.exports = __webpack_public_path__ + "static/media/splash-preview.e5937f3a.svg";